import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@draeger-academy/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DaLinkModule } from '../da-link';
import { CookieService } from 'ngx-cookie-service';
import { BreadcrumbComponent } from './breadcrumb.component';
import { ResponsiveModule, IResponsiveConfig } from '@viablelogic/ngx-responsive';

const config : IResponsiveConfig = {
    breakPoints: {
        xs:  { max: 479 },
        sm:  { min: 480,  max: 767 },
        md:  { min: 768,  max: 959 },
        lg:  { min: 960,  max: 1119 },
        xl:  { min: 1120, max: 99999 }, // <-- workaround, as no sizes larger than xl are defined in the design
        xxl: { min: 100000}             // <-- ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    },
    debounceTime: 100
};

@NgModule({
    imports: [CommonModule, RouterModule, ResponsiveModule.forRoot(config), DaLinkModule, LocalizeRouterModule.forChild([])],
    declarations: [BreadcrumbComponent],
    exports: [BreadcrumbComponent],
    providers: [CookieService]
})
export class BreadcrumbModule {}
